// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-count__title[data-v-e23f0918]{margin-bottom:30px;color:#4fc08d}.vue-count__btn[data-v-e23f0918]{margin-top:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
